import * as Types from '../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RejectInvitationMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type RejectInvitationMutation = { __typename?: 'Mutation', rejectInvite: { __typename?: 'Invite', id: string } };


export const RejectInvitationDocument = gql`
    mutation RejectInvitation($id: ID!) {
  rejectInvite(data: {id: $id}) {
    id
  }
}
    `;
export type RejectInvitationMutationFn = Apollo.MutationFunction<RejectInvitationMutation, RejectInvitationMutationVariables>;

/**
 * __useRejectInvitationMutation__
 *
 * To run a mutation, you first call `useRejectInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectInvitationMutation, { data, loading, error }] = useRejectInvitationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRejectInvitationMutation(baseOptions?: Apollo.MutationHookOptions<RejectInvitationMutation, RejectInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectInvitationMutation, RejectInvitationMutationVariables>(RejectInvitationDocument, options);
      }
export type RejectInvitationMutationHookResult = ReturnType<typeof useRejectInvitationMutation>;
export type RejectInvitationMutationResult = Apollo.MutationResult<RejectInvitationMutation>;
export type RejectInvitationMutationOptions = Apollo.BaseMutationOptions<RejectInvitationMutation, RejectInvitationMutationVariables>;